import { type JSX, type ReactNode } from "react";

import {
  Field,
  FieldContent,
  FieldError,
  FieldLabel,
} from "@frontend/components/atoms/Field";
import { useField } from "@frontend/hooks/form";
import type { NumberField } from "@frontend/lib/form";
import { useLingui } from "@lingui/react/macro";

import type { ClientOption } from "../types";
import { ClientCombobox } from "./ClientCombobox";

export type ClientFieldProps = {
  field: NumberField<number | null | undefined>;
  label?: ReactNode;
  fallbackLabel?: string | null;
  disabled?: boolean;
  error?: string | null;
  onClientSelected?: (client: ClientOption | null) => void;
};

export function ClientField({
  field,
  label,
  fallbackLabel,
  disabled,
  error,
  onClientSelected,
}: ClientFieldProps): JSX.Element {
  const { t } = useLingui();

  const {
    value: clientId,
    setValue: setClientId,
    error: fieldError,
  } = useField(field);

  const said = error ?? fieldError;

  return (
    <Field invalid={Boolean(said)}>
      <FieldLabel>{label ?? t`Client`}</FieldLabel>

      <FieldContent>
        <ClientCombobox
          value={clientId}
          fallbackLabel={fallbackLabel}
          disabled={disabled}
          onValueChange={(client) => {
            setClientId(client?.id ?? undefined);
            onClientSelected?.(client);
          }}
        />

        <FieldError match={Boolean(said)}>{said}</FieldError>
      </FieldContent>
    </Field>
  );
}
